<section class="ag-grid">
  <dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
    <dx-data-grid
      #logOutcomeStatusesGridRef
      class="ag-grid__component"
      [dataSource]="outcomeStatusUpdatesDataSource"
      [showBorders]="false"
      [remoteOperations]="false"
      [syncLookupFilterValues]="false"
      [columnAutoWidth]="true"
      [scrollLeft]="true"
      [allowColumnReordering]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [focusedRowEnabled]="false"
      [focusedColumnIndex]="0"
      [autoNavigateToFocusedRow]="false"
      [wordWrapEnabled]="true"
      [showRowLines]="true"
      [noDataText]="'No Updates'"
      width="100%"
      height="100%"
    >
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-header-filter [visible]="false"></dxo-header-filter>
      <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>

      <dxo-editing
        mode="popup"
        [useIcons]="true"
        [allowUpdating]="false"
        [allowDeleting]="false"
        [allowAdding]="false"
      ></dxo-editing>

      <dxo-toolbar>
        <dxi-item name="searchPanel" cssClass="ag-grid__toolbar-control"></dxi-item>
      </dxo-toolbar>

      <dxi-column
        [width]="200"
        [dataField]="BaseModelKeys.createdDate"
        caption="Date"
        [allowEditing]="false"
        [dataType]="'date'"
        [sortOrder]="'desc'"
        [format]="dateFormat"
      ></dxi-column>

      <dxi-column
        [dataField]="BaseModelKeys.createdByAgentDbId"
        caption="Who Change"
        cellTemplate="createdByAgentDbIdCellTemplate"
        [lookup]="{ dataSource: agentsLookupDataSourceConfiguration, valueExpr: BaseModelKeys.dbId, displayExpr: AgentKeys.p_agent_name }"
      >
        <div *dxTemplate="let cell of 'createdByAgentDbIdCellTemplate'">
          <ng-container *var="agentsMap$ | async as agentsMap">
            <span *var="agentsMap[cell.value] as agent">
              {{ agent?.[AgentKeys.p_agent_name] }} ({{ agent?.[AgentKeys.p_email] | empty }})
            </span>
          </ng-container>
        </div>
      </dxi-column>

      <dxi-column
        [dataField]="ConferenceLogBulkInviteeOutcomeStatusKeys.newOutcomeStatus"
        caption="Resulted Invitee Status"
      >
        <dxo-lookup
          [dataSource]="inviteeOutcomeStatusLookup"
          [allowClearing]="false"
          [displayExpr]="LookupKeys.description"
          [valueExpr]="LookupKeys.value"
        ></dxo-lookup>
      </dxi-column>

      <dxi-column
        [dataField]="'wasabiPath'"
        caption="Changes File"
        cellTemplate="fileCellTemplate"
        alignment="left"
      ></dxi-column>
      <div *dxTemplate="let cell of 'fileCellTemplate'">
        <a *ngIf="cell.value" [href]="cell.value | wasabiFile">Download</a>
      </div>
    </dx-data-grid>
  </dx-scroll-view>
</section>
